import { render, staticRenderFns } from "./FormGallery.vue?vue&type=template&id=5a3375f0&"
import script from "./FormGallery.vue?vue&type=script&lang=js&"
export * from "./FormGallery.vue?vue&type=script&lang=js&"
import style0 from "./FormGallery.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports